import React from 'react';
import './solutionpanel.css';
import { Icon, Button, Collapse } from '@blueprintjs/core';

export default class SolutionPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isOpen: false };
    }

    render() {
        return <div className="solutionpanel-container">
            <div className="solutionpanel-header">
                <div className={`solutionpanel-header-right ${this.state.isOpen ? "solutionpanel-header-open": "solutionpanel-header-closed"}`}>
                    <Button minimal="true" icon={(<Icon icon="caret-right" iconSize={Icon.SIZE_LARGE} />)}  small="false" 
                            onClick={() => this.setState({isOpen: !this.state.isOpen}) }
                    />
                </div>
                <div ref={this.titleRef} className="solutionpanel-header-title" onClick={() => this.setState({isOpen: !this.state.isOpen}) }>
                    {this.props.title}
                </div>
            </div>
            <Collapse isOpen={this.state.isOpen}>
                    {this.props.children}
            </Collapse>
        </div>;
    }

}
